import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { getToken } from '../../selectors/base.selectors';
import { BaseActionTypes } from '../../actions/base.actions';
import { State } from '../../index';
import { TEGueltigkeitEntity } from '../../../entities/mdqx/te-gueltigkeit.entity';
import { HttpService } from '../../../services/http.service';
import { GetTEGueltigkeitenResponse, TEGueltigkeitActionTypes } from '../../actions/mdqx/te-gueltigkeit.actions';
import { DaveActions } from '../../actions/actions';
import { environment } from '../../../../../environments/environment';

enum ErrorCodes {
    Get = 'TE-Gültigkeiten Abrufen fehlgeschlagen',
}

@Injectable()
export class TEGueltigkeitEffects {
    
    get$ = createEffect(() => this.actions$.pipe(
        ofType(TEGueltigkeitActionTypes.GetTEGueltigkeitenRequest),
        map(
            () => `
            {
                tegueltigkeit {
                    ${TEGueltigkeitEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token }, '', environment.mdqxGatewayApiUrl).pipe(
                map(res => res && res.tegueltigkeit),
                concatMap(res =>
                    res
                        ? [
                              new GetTEGueltigkeitenResponse(
                                  res.map(teGueltigkeit => new TEGueltigkeitEntity(teGueltigkeit)),
                              ),
                          ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions<DaveActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {}
}
